import { useTranslation } from 'react-i18next';

const getFileSizeNotice = (maxFileSizeMB, maxNumberOfFiles) => {
    const { t } = useTranslation('DropZone');

    const fileSizeNotice = t(
        'theme.dropzone.max-file-size',
        { maxFileSize: `${maxFileSizeMB} MB` },
    );
    const fileContentNotice = t(
        'theme.dropzone.max-number-of-files',
        { maxNumberOfFiles },
    );

    return `* ${fileSizeNotice}. ${fileContentNotice}.`;
};

export default getFileSizeNotice;
